import { IonCol, IonGrid, IonIcon, IonRow } from '@ionic/react';
import React from 'react';

import { chevronForward } from 'ionicons/icons';

import './OptionCard.scss';
import { OptionCardProps } from './types';

const OptionCard: React.FC<OptionCardProps> = ({
  onClick,
  icon,
  title,
  description,
  disabled = false,
}) => (
  <div
    className={`option-card${disabled ? ' option-card--disabled' : ''}`}
    onClick={onClick}
    aria-disabled={disabled}
  >
    <IonGrid>
      <IonRow className="ion-align-items-center">
        <IonCol size="auto">
          <div className="option-card__icon">{icon}</div>
        </IonCol>

        <IonCol className="option-card__content">
          <div className="option-card__content--title">{title}</div>
          {description && (
            <div className="option-card__content--description">{description}</div>
          )}
        </IonCol>

        <IonCol size="auto">
          <IonIcon icon={chevronForward} />
        </IonCol>
      </IonRow>
    </IonGrid>
  </div>
);

export default React.memo(OptionCard);
